import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';

import appReducer from '../features/app/AppSlice';
import homeReducer from '../features/home/HomeSlice';
import merchantOnboardingReducer from '../features/merchant-onboarding/MerchantOnboardingSlice';
import userManagementReducer from '../features/user-management/UserManagementSlice';
import accountManagementReducer from '../features/account-management/AccountManagementSlice';
import challengeDisputeReducer from '../features/challenge-dispute/ChallengeDisputeSlice';
import helpReducer from '../features/help/HelpSlice';

export const rootReducer = combineReducers({
  app: appReducer,
  home: homeReducer,
  merchantOnboarding: merchantOnboardingReducer,
  userManagement: userManagementReducer,
  accountManagement: accountManagementReducer,
  challengeDispute: challengeDisputeReducer,
  help: helpReducer,
});

const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export type AppDispatch = typeof store.dispatch;

export default store;
